// extracted by mini-css-extract-plugin
export default {"nav_rr_menu_item_switch":"switch_nav_rr_menu_item_switch__n7OaL","nav_rr_menu_item_switch_control":"switch_nav_rr_menu_item_switch_control__-8nZf"};